import React, { useState, useEffect, useRef, useMemo } from 'react'
import { DateSkipper, GraviButton, GraviGrid, Horizontal, onExport } from '@gravitate-js/excalibrr'
import api from '@utils/api'
import moment from 'moment'
import { supplyReportCR } from './Columns/SupplyCellRenderers'
import { DownloadOutlined } from '@ant-design/icons'
import { Tooltip } from 'antd'
import { getColumnDefs } from './Columns/columnDefs'
import { formatters } from '@utils/intl/dateTimeFormatters'
import { useUserSettings } from '@hooks/settings'
import { gridViewManager } from '@/utils/grid'

const STORAGE_KEY = 'supply-report'

export const SupplyReport = () => {
  const now = moment().local()
  const date = formatters.DATE(now)
  const [rowData, setRowData] = useState()
  const [serverParams, setServerParams] = useState()
  const [loading, setLoading] = useState(true)
  const [filters, setFilters] = useState({ as_of: new Date() })
  const gridAPIRef = useRef()
  useEffect(() => {
    setLoading(true)
    api.getSupplyReportAll(filters).then((resp) => {
      if (resp) {
        setRowData(resp.data.rows)
        setServerParams(resp.data.params)
        setLoading(false)
      }
    })
  }, [filters])

  const onDayChange = (date, dateString) => {
    setLoading(true)
    const sendDate = new Date(date).toISOString()
    setFilters({
      ...filters,
      as_of: sendDate,
    })
  }
  const excelParams = {
    fileName: `supply_${new Date().toLocaleDateString()}.xlsx`,
    sheetName: 'Supply Report',
    processCellCallback: (params) => {
      if (params.value && (params.column.colId === 'effective_from' || params.column.colId === 'effective_to')) {
        return formatters.DATE_TIME(moment(params.value))
      } else if (params.column.colId === 'status') {
        return params.value || 'N/A'
      } else {
        return params.value
      }
    },
  }
  const { updateSetting } = useUserSettings()

  const agPropOverrides = useMemo(
    () => ({
      frameworkComponents: supplyReportCR,
      columnDefaultOverrides: { minWidth: 100, enableRowGroup: true },
      getRowId: (row) => row?.data?.key,
    }),
    []
  )
  const columnDefs = useMemo(getColumnDefs, [])

  return (
    <GraviGrid
      externalRef={gridAPIRef}
      controlBarProps={{
        title: 'Supply Report',
        actionButtons: (
          <Horizontal gap={16}>
            <Tooltip title='Download Report'>
              <GraviButton
                success
                icon={<DownloadOutlined />}
                appearance='outline'
                onClick={() => onExport(gridAPIRef, excelParams)}
              />
            </Tooltip>
            <Horizontal verticalCenter gap={0}>
              <DateSkipper startDate={filters.as_of} onChange={onDayChange} daysToSkip={1} format={formatters.DATE} />
            </Horizontal>
          </Horizontal>
        ),
        hiddenFilterKeys: ['as_of'],
        serverParams,
        filters,
        setFilters,
      }}
      agPropOverrides={agPropOverrides}
      columnDefs={columnDefs}
      storageKey={STORAGE_KEY}
      rowData={rowData}
      suppressPivot={false}
      loading={loading}
      onGridConfigChanged={(config) => updateSetting(`gridConfig::${STORAGE_KEY}`, config)}
      {...gridViewManager(STORAGE_KEY, updateSetting)}
    />
  )
}
